import { GET_TESTIMONIALS_LIST } from './constants'
import TestimonialsListService from '../TestimonialsListService'


export const getTestimonialsListAction = () => async (dispatch) => {
  const testimonialsList = await TestimonialsListService.getTestimonialsList()

  dispatch({
    type: GET_TESTIMONIALS_LIST,
    payload: testimonialsList,
  })
}
